import { useEffect, useRef } from 'react';

type UsePersistentlyPlacedPopoverOptions = {
  onSizeChange?: () => void;
};

export const usePersistentlyPlacedPopover = (
  isOpen: boolean,
  options?: UsePersistentlyPlacedPopoverOptions
): { contentRef: React.RefObject<HTMLDivElement> } => {
  const contentRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!isOpen || !contentRef.current) return;
    const ro = new ResizeObserver(() => {
      window.dispatchEvent(new Event('resize'));
      if (options?.onSizeChange) options.onSizeChange();
    });
    ro.observe(contentRef.current);
    return () => {
      ro.disconnect();
    };
  }, [isOpen, options]);

  return { contentRef };
};
